// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsGuestBillingInvoiceApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AdProductsGuestPayInvoicesDto,
  AdproductsGuestPaySupportRequestDto,
  GuestPayPaymentMethodDto,
  SaveGuestPayInvoiceSelectionRequestDto,
  UserZuoraPaymentMethodDto,
} from '../..';

interface GetInvoicesByNumberAndAccountParams {
  accountNumber: string;
  guestPayEmail: string;
  invoiceNumber: string;
}
interface GetInvoicesByNumberAndAccountForGuestParams {
  accountNumber: string;
  guestPayEmail: string;
  invoiceNumber: string;
}
interface GetPaymentMethodDetailsParams {
  guestPaySessionId: string;
}
interface IsGuestPayEligibleParams {
  accountNumber: string;
  invoiceNumber: string;
}

export const AdproductsGuestBillingInvoiceApiHandler_getInvoicesByNumberAndAccount_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/getInvoicesByNumberAndAccount';

export const AdproductsGuestBillingInvoiceApiHandler_getInvoicesByNumberAndAccount = (
  getParams: GetInvoicesByNumberAndAccountParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetInvoicesByNumberAndAccountParams, never, AdProductsGuestPayInvoicesDto>(
    {
      getParams: getParams,
      endpoint: AdproductsGuestBillingInvoiceApiHandler_getInvoicesByNumberAndAccount_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsGuestBillingInvoiceApiHandler_getInvoicesByNumberAndAccountForGuest_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/getInvoicesByNumberAndAccountForGuest';

export const AdproductsGuestBillingInvoiceApiHandler_getInvoicesByNumberAndAccountForGuest = (
  getParams: GetInvoicesByNumberAndAccountForGuestParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetInvoicesByNumberAndAccountForGuestParams, never, AdProductsGuestPayInvoicesDto>(
    {
      getParams: getParams,
      endpoint: AdproductsGuestBillingInvoiceApiHandler_getInvoicesByNumberAndAccountForGuest_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsGuestBillingInvoiceApiHandler_getPaymentMethodDetails_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/getPaymentMethodDetails';

export const AdproductsGuestBillingInvoiceApiHandler_getPaymentMethodDetails = (
  getParams: GetPaymentMethodDetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPaymentMethodDetailsParams, never, UserZuoraPaymentMethodDto>(
    {
      getParams: getParams,
      endpoint: AdproductsGuestBillingInvoiceApiHandler_getPaymentMethodDetails_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsGuestBillingInvoiceApiHandler_isGuestPayEligible_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/isGuestPayEligible';

export const AdproductsGuestBillingInvoiceApiHandler_isGuestPayEligible = (
  getParams: IsGuestPayEligibleParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsGuestPayEligibleParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: AdproductsGuestBillingInvoiceApiHandler_isGuestPayEligible_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsGuestBillingInvoiceApiHandler_saveGuestPayInvoiceSelection_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/saveGuestPayInvoiceSelection';

export const AdproductsGuestBillingInvoiceApiHandler_saveGuestPayInvoiceSelection = (
  postData: SaveGuestPayInvoiceSelectionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SaveGuestPayInvoiceSelectionRequestDto, void>(
    {
      endpoint: AdproductsGuestBillingInvoiceApiHandler_saveGuestPayInvoiceSelection_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsGuestBillingInvoiceApiHandler_saveGuestPayInvoiceSelectionForGuest_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/saveGuestPayInvoiceSelectionForGuest';

export const AdproductsGuestBillingInvoiceApiHandler_saveGuestPayInvoiceSelectionForGuest = (
  postData: SaveGuestPayInvoiceSelectionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SaveGuestPayInvoiceSelectionRequestDto, void>(
    {
      endpoint: AdproductsGuestBillingInvoiceApiHandler_saveGuestPayInvoiceSelectionForGuest_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsGuestBillingInvoiceApiHandler_sendGuestPaySupportEmail_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/sendGuestPaySupportEmail';

export const AdproductsGuestBillingInvoiceApiHandler_sendGuestPaySupportEmail = (
  postData: AdproductsGuestPaySupportRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AdproductsGuestPaySupportRequestDto, void>(
    {
      endpoint: AdproductsGuestBillingInvoiceApiHandler_sendGuestPaySupportEmail_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsGuestBillingInvoiceApiHandler_updateGuestPayPaymentMethodDetails_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/updateGuestPayPaymentMethodDetails';

export const AdproductsGuestBillingInvoiceApiHandler_updateGuestPayPaymentMethodDetails = (
  postData: GuestPayPaymentMethodDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GuestPayPaymentMethodDto, void>(
    {
      endpoint: AdproductsGuestBillingInvoiceApiHandler_updateGuestPayPaymentMethodDetails_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};
